import { render } from "./AdminDashboardVie.vue?vue&type=template&id=0ebfd812"
import script from "./AdminDashboardVie.vue?vue&type=script&lang=js"
export * from "./AdminDashboardVie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__